import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { Plan, planType } from "../../types/slices/planType";
import { RootState } from "../store";

const initialState: planType = {
    status: ApiStatus.FETCHED,
    plans: [],
    planSelected: {} as Plan,
    errorMessage: undefined
}

const planSlice = createSlice({
    name: 'planSlice',
    initialState,
    reducers: {
        onFetchPlans(state, { payload }: { payload: Plan[] }) {
            state.status = ApiStatus.FETCHED
            state.plans = payload
            state.errorMessage = undefined
        },
        onSetSelectedPlan(state, { payload }: { payload: Plan }) {
            state.planSelected = payload
        },
        changeStatus(state, { payload }: { payload: ApiStatus }) {
            state.status = payload
        }
    }
})

export const selectPlanState = (state: RootState) => state.planSlice
export default planSlice.reducer
export const {
    onFetchPlans,
    onSetSelectedPlan,
    changeStatus
} = planSlice.actions